<template>
    <div class="container">
        <el-row class="user-info">
            <!-- 上部 -->
            <el-row class="content-top">
                <!-- 上部左侧部分 -->
                <el-col :span="3" class="content-top-left" style="text-align:right">
                    <!-- 头像部分 -->                  
                    <el-avatar :size="60" :src="userImg"></el-avatar>                  
                </el-col>
                <!-- 上部右侧部分 -->
                <el-col :span="20" :offset="1" class="content-top-right">
                    <h3>哒哒哒</h3>
                    <p>
                        <span>5年</span>|
                        <span>七岁</span>|
                        <span>本科</span>|
                        <span>离职-可马上到岗</span>
                    </p>
                    <div class="content">
                        熟练使用Vue.js全家桶， nuxt.js等ssr框架，Sass等css预编译语言，Webpack等构建工具，Mock.js等
                        mock工具，svn等版本控制工具，h5+plus/uni app等移动应用开发方案，百度地图等地图调用服务。
                        较熟练使用ECharts等图表库，WebSocket，Canvas，Express等基于nodejs的后台web服务器框架，
                        mysql等技术。
                    </div>
                </el-col>
            </el-row>

            <!-- 下部 -->
            <el-row>
                <!-- 下部部分 -->
                <el-col class="content-bottom">
                    <!-- 下部期望 -->
                    <el-row class="job-row">
                        <el-col :span="3" class="tit-box">
                            <span class="tit">期望职位</span>
                        </el-col>
                        <el-col :span="20" :offset="1" class="content">
                            <p class="font">安卓开发工程师、web前端 12-18k</p>
                        </el-col>
                    </el-row>

                    <el-row class="addr-row">
                        <el-col :span="3" class="tit-box">
                            <span class="tit">期望地点</span>
                        </el-col>
                        <el-col :span="20" :offset="1" class="content">
                            <p class="font">东营</p>
                        </el-col>
                    </el-row>

                    <!-- 下部工作经历 -->
                    <el-row class="job-row-box">

                        <el-row class="pd">
                            <el-col :span="3" class="tit-box">
                                <span class="tit">工作经历</span>
                            </el-col>
                            <el-col :span="20" :offset="1" class="company">
                                <p class="font">嘉诺维（武汉）信息技术有限公司  |   web前端</p>
                                <p class="date">
                                    <span>2017-02 </span>—
                                    <span> 2018-1</span>
                                </p>
                            </el-col>
                        </el-row>

                        <el-row class="pd work-row">
                            <el-col :span="3" class="tit-box">
                                <span class="tit">内容</span>
                            </el-col>
                            <el-col :span="20" :offset="1" class="content">
                                <p>1.负责根据ui设计稿还原页面。和项目经理协定需求的具体实现方式。</p>
                                <p>2.负责公司的管理系统网站的前端开发，公司由我搭起项目的nuxt框架配置。</p>
                            </el-col>
                        </el-row>

                    </el-row>
                     <el-row class="job-row-box">

                        <el-row class="pd">
                            <el-col :span="3" class="tit-box">
                                <span class="tit"></span>
                            </el-col>
                            <el-col :span="20" :offset="1" class="company">
                                <p class="font">嘉诺维（武汉）信息技术有限公司  |   web前端</p>
                                <p class="date">
                                    <span>2017-02 </span>—
                                    <span> 2018-1</span>
                                </p>
                            </el-col>
                        </el-row>

                        <el-row class="pd work-row">
                            <el-col :span="3" class="tit-box">
                                <span class="tit">内容</span>
                            </el-col>
                            <el-col :span="20" :offset="1" class="content">
                                <p>1.负责根据ui设计稿还原页面。和项目经理协定需求的具体实现方式。</p>
                                <p>2.负责公司的管理系统网站的前端开发，公司由我搭起项目的nuxt框架配置。</p>
                            </el-col>
                        </el-row>

                    </el-row>


                    <!-- 下部教育经历 -->
                     <el-row class="job-row-box">

                        <el-row class="pd">
                            <el-col :span="3" class="tit-box">
                                <span class="tit">教育经历</span>
                            </el-col>
                            <el-col :span="20" :offset="1" class="school">
                                <p class="font">湖北理工大学  |   本科   |    计算机专业</p>
                                <p class="date">
                                    <span>2017-02 </span>—
                                    <span> 2018-1</span>
                                </p>
                            </el-col>
                        </el-row>
                    </el-row>
                    
                   

                </el-col>
               
           
            </el-row>

        </el-row>
    </div>
</template>
<script>
export default {
    data(){
        return {
            userImg:'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
        }
    }
}
</script>
<style lang="less" scoped>
    .container{
        padding:35px 25px;
    }
    .user-info{
        // margin-top:20px;
    }
   
   // 上部
    .content-top-right{
    
        h3{
            display:inline-block;     
            font-weight: 500;
            color: #333333;
            line-height: 30px;
        }
        p{
            float:right;         
            font-weight: 400;
            color: #666666;
            line-height: 30px;
            font-size:14px;
            span{
                padding:0 5px;
            }
        }
        .content{  
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 24px;
            margin-top:10px;
        }
    }

    // 下部期望
    .tit-box{
        text-align:right;
        .tit{
            font-size: 16px;
            font-weight: 400;
            color: #666666;
        }
    }
    .addr-row,
    .job-row{
        padding-top:20px;
        .font{   
            font-size: 16px;
            font-weight: 400;
            color: #333333;
        }
    }


    // 下部工作经历

        .job-row-box{
            .company{ 
                .font{
                    font-size: 18px;
                    font-weight: 400;
                    color: #666666;
                    float:left;
                } 
                .date{
                    float:right;
                    font-size: 14px;
                    font-weight: 400;
                    color: #666666;
                }
            }
            .pd{
                padding-top:27px;
                .tit{
                    display:inline-block;
                    width:100%;
                    height:100%;
                }
            }
            .pd.work-row{
                padding-top:20px;
            }
            .content{ 
                p{
                    font-size: 15px;
                    font-weight: 400;
                    color: #333333;
                    padding-bottom:13px;
                }    
            }
        }

    // 下部教育经历
        .school{
            .font{
                font-size: 16px;
                font-weight: 400;
                color: #333333;
                float:left;
            }
            .date{
                float:right;
                font-size: 14px;
                font-weight: 400;
                color: #666666;
            }
        }
</style>